import { createContext, useContext } from "react";
import { isNil, mergeProps } from "../../shared";
import { jsx as _jsx } from "react/jsx-runtime";
export const InputGroupContext = /*#__PURE__*/createContext(null);
export function useInputGroupContext() {
  const context = useContext(InputGroupContext);
  return !isNil(context) ? [context, true] : [{}, false];
}
export function ClearInputGroupContext({
  children
}) {
  return /*#__PURE__*/_jsx(InputGroupContext.Provider, {
    value: null,
    children: children
  });
}
/* Inputs */

export function useInputGroupProps() {
  const [context, isInInputGroup] = useInputGroupContext();
  const props = isInInputGroup && mergeProps(context, {
    className: "o-ui-input-group-input"
  });
  return [props || {}, isInInputGroup];
}
export function useInputGroupTextInputProps() {
  const [context, isInInputGroup] = useInputGroupContext();
  const props = isInInputGroup && mergeProps(context, {
    className: "o-ui-input-group-input o-ui-input-group-text-input"
  });
  return [props || {}, isInInputGroup];
}
/* Addons */

export function useInputGroupAddonProps() {
  const [{
    disabled
  }, isInInputGroup] = useInputGroupContext();
  const props = isInInputGroup && {
    className: "o-ui-input-group-addon",
    disabled
  };
  return [props || {}, isInInputGroup];
}
export function useInputGroupButtonAddonProps() {
  const [{
    disabled
  }, isInInputGroup] = useInputGroupContext();
  const props = isInInputGroup && {
    className: "o-ui-input-group-addon  o-ui-input-group-button-addon",
    disabled,
    shape: "rounded"
  };
  return [props || {}, isInInputGroup];
}
export function useInputGroupMenuAddonProps() {
  const [{
    disabled,
    readOnly
  }, isInInputGroup] = useInputGroupContext();
  const props = isInInputGroup && {
    className: "o-ui-input-group-addon o-ui-input-group-menu-addon",
    disabled,
    readOnly
  };
  return [props || {}, isInInputGroup];
}
export function useInputGroupSelectAddonProps() {
  const [{
    disabled,
    readOnly
  }, isInInputGroup] = useInputGroupContext();
  const props = isInInputGroup && {
    allowResponsiveMenuWidth: false,
    className: "o-ui-input-group-addon o-ui-input-group-select-addon",
    disabled,
    readOnly
  };
  return [props || {}, isInInputGroup];
}